import * as React from "react"
import { SVGProps } from "react"
const Alert = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" {...props}>
    <g fill="red">
      <circle cx={64} cy={18} r={8} />
      <path d="M64 24c-18 0-28 14-28 32v26L22 96v8h84v-8L92 82V56c0-18-10-32-28-32Z" />
      <circle cx={64} cy={112} r={10} />
    </g>
    <rect width={12} height={30} x={58} y={44} rx={2} />
    <circle cx={64} cy={86} r={6} />
  </svg>
)
export default Alert
